import { Pipe, PipeTransform } from '@angular/core';

import { Product, PromotionsModel } from '@bytel/bytel-sales';

@Pipe({
    name: 'priceCoupon',
    pure: true,
    standalone: true,
})
/**
 * Temp pipe - remove when elig promo return prorata coupon price
 */
export class PriceCouponPipe implements PipeTransform {
    transform(product: Product): number {
        let price: number = product.prices.base;

        const promotions = product.promotions.automatic.concat(product.promotions.manual);
        price -= promotions.reduce((acc, promotion) => acc + promotion.reductionAmount, 0);

        return Math.max(product.minPromoPrice, PromotionsModel.roundPrice(price));
    }
}
